export const required = {
	validate(value, input, form) {
		if (input.tagName === 'SELECT') {
			return input.querySelector('[selected]');
		}

		return value.length > 0;
	},
	message(value, input, form) {
		return form.dataset?.errorRequired;
	},
};

const namePattern = /^[\p{L}\s'’-]+$/u;

export const name = {
	validate(value, input, form) {
		if (!value) {
			return true;
		}

		const trimmed = value.trim();

		return /\p{L}/u.test(trimmed) && namePattern.test(trimmed);
	},
	message(value, input, form) {
		return form.dataset?.errorInvalidName || form.dataset?.errorName;
	},
};

export const phone = {
	validate(value, input, form) {
		const iti = input.closest('intl-tel').iti;
		return !iti || iti.isValidNumber();
	},
	message(value, input, form) {
		return form.dataset?.errorPhone;
	},
	mask(value, input, form) {

	},
};

export const email = {
	validate(value, input, form) {
		return !value || value.match(/(.*)@(.*)\.\w{2,}/);
	},
	message(value, input, form) {
		return form.dataset?.errorEmail;
	},
};

export const nip = {
	async validate(value, input, form) {
		const companyField = form.querySelector('[name="shipping_address[company]"]');
		if (!companyField.value && !value) return true;

		if (value.length !== 10) return false;

		const action = `index.php?route=extension/evasota/checkout/checkout.validateNip&nip=${value}`;
		const response = await fetch(action, {
			method: 'GET',
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		});

		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`);
		}

		const result = await response.json();

		return result.success;
	},
	message(value, input, form) {
		console.log(form.dataset?.errorNip);
		return form.dataset?.errorNip;
	},
	mask(value, input, form) {
		// I don't have a mask
	}
}
